import { h } from "preact";
import { useRef } from "preact/hooks";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import Alert from "../../components/Alert";
function CartCoupon(props) {
    const { state } = props;
    const inputRef = useRef(null);
    switch (state.type) {
        case "Disabled":
        case "Init":
            return null;
        // NOTICE: Promotions view experiment
        // https://restaumatic.atlassian.net/browse/B2C-1040
        // case "Init": {
        //   const handleClick = (event: Event) => {
        //     event.preventDefault();
        //     state.showForm();
        //   };
        //   return (
        //     <div data-field-id="Cart.couponCode" class="cart-multi-column mobile">
        //       <div class="column info">
        //         <span>Masz kupon promocyjny?</span>
        //         <div>
        //           <button
        //             type="button"
        //             class="btn-link u-text-transform-none u-p0"
        //             onClick={handleClick}
        //             data-field-id="Cart.couponCode.begin"
        //           >
        //             Wpisz kod kuponu
        //           </button>
        //         </div>
        //       </div>
        //     </div>
        //   );
        // }
        case "Form": {
            const handleSubmit = (event) => {
                var _a;
                event.preventDefault();
                const code = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
                if (code === undefined) {
                    throw new Error("Coupon code input value is undefined");
                }
                void state.submit(code);
            };
            return (h("div", { class: "item promotion" },
                h("div", { class: "cart-multi-column mobile" },
                    h("div", { class: "column info" },
                        h("label", { htmlFor: "cart-coupon-code", class: "control-label name" }, translate(t.coupon_promotion.default_name)),
                        h("form", { onSubmit: handleSubmit, disabled: state.isLoading, class: "input-append coupon-input" },
                            h("input", { ref: inputRef, id: "cart-coupon-code", class: "form-control form-control--inline", "data-field-id": "coupon.code", required: true, placeholder: translate(t.restaurants.widgets.cart_items.coupon_item.placeholder) }),
                            h("button", { type: "submit", class: "btn btn-default", "data-field-id": "coupon.submit", disabled: state.isLoading }, translate(t.restaurants.menu.add))),
                        state.errorMessage !== null && (h(Alert, { type: "danger", message: state.errorMessage }))))));
        }
        case "Applied":
            return (h("div", { class: "item promotion" },
                h("div", { class: "cart-multi-column mobile" },
                    h("div", { class: "column info" },
                        h("span", { class: "name" }, translate(t.coupon_promotion.default_name)),
                        h("p", { class: "description" }, state.description)),
                    h("div", { class: "column subtotal" },
                        h("button", { onClick: () => state.remove(), class: "btn btn-default", type: "button" }, translate(t.restaurants.menu.remove))))));
    }
}
export default observer(CartCoupon);
